import { electronApis } from '@/features/electron-api';

import { ckDebugStore } from './ck-debug.store';

export function setupCkDebugListeners(signal: AbortSignal) {
  const unlisten = electronApis.context.listenForDebugSnapshotReport(
    (payload) => {
      ckDebugStore.addSnapshot(payload);
    }
  );

  signal.addEventListener('abort', () => {
    unlisten();
  });
}

export function enableDebugStream() {
  electronApis.context.enableDebugStream();
}

export function disableDebugStream() {
  electronApis.context.disableDebugStream();
}

export function triggerManualSnapshot() {
  electronApis.context.triggerManualSnapshot();
}
